import React from "react";
import { Link } from "react-router-dom";

export function EditorialText({ text, testId }) {
  return String(text).split(/(\[[^\]]+\]\([^)]+\))/g).map((part, i) => {
    const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if (!link) return part;
    const props = { "data-testid": `${testId}-link-${i}`, className: "underline underline-offset-4 decoration-[#B3A17D] hover:text-[#451C25] transition-colors" };
    return link[2].startsWith("/")
      ? <Link key={i} to={link[2]} {...props}>{link[1]}</Link>
      : <a key={i} href={link[2]} target="_blank" rel="noopener noreferrer" {...props}>{link[1]}</a>;
  });
}

export function PillarEditorial({ sections, route }) {
  if (!sections?.length) return null;
  return (
    <div data-testid="pillar-editorial" className="px-6 md:px-10 lg:px-14 py-16 md:py-20">
      <div className="max-w-3xl mx-auto space-y-12">
        {sections.map((section, i) => (
          <section key={section.heading} data-testid={`pillar-section-${i}`}>
            <h2 className="text-base md:text-lg font-semibold" style={{ fontFamily: "Kanit, sans-serif" }}>{section.heading}</h2>
            <div className="mt-5 space-y-5 text-sm md:text-base leading-relaxed text-[#6B4954]" style={{ fontFamily: "'Noto Serif', Georgia, serif" }}>
              {section.paragraphs.map((text, j) => <p key={j}><EditorialText text={text} testId={`${route}-section-${i}-paragraph-${j}`} /></p>)}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}

export function PillarSources({ sources, reviewed, route }) {
  if (!sources?.length) return null;
  return (
    <aside data-testid="pillar-sources" className="px-6 md:px-10 lg:px-14 py-12 border-t border-[#451C25]/10">
      <div className="max-w-3xl mx-auto text-sm leading-relaxed text-[#6B4954]">
        <h2 className="text-base md:text-lg text-[#451C25] font-semibold">Sources and review</h2>
        <p data-testid="pillar-reviewed-date" className="mt-3">Last reviewed: <time dateTime={reviewed}>{reviewed}</time>. General planning information, not individual legal, tax, medical or financial advice. Confirm requirements with the relevant authority and qualified professionals before acting.</p>
        <ul className="mt-4 space-y-2">
          {sources.map(([label, url], i) => <li key={url}><a data-testid={`${route}-source-${i}`} href={url} target="_blank" rel="noopener noreferrer" className="underline underline-offset-4 decoration-[#B3A17D] hover:text-[#451C25] transition-colors">{label}</a></li>)}
        </ul>
      </div>
    </aside>
  );
}